import { ApiClient } from '@provider-portal/common/api';

import { Bugsnag } from '@bolteu/bugsnag-service-react-web';
import { ApiError } from '@bolteu/react-api-gateway/es';
import { CredentialsSessionEpicDependencies } from '@bolteu/redux-session';

import { getDeviceInfo, getDeviceUniqueId } from 'utils/deviceInfo';

interface CredentialsWithMagicLink {
  username?: string;
  password?: string;
  token?: string;
}

export const createCredentialsSessionEpicDependencies = (
  apiClient: ApiClient,
  bugsnag: Bugsnag.Service,
): CredentialsSessionEpicDependencies => {
  return <CredentialsSessionEpicDependencies>{
    api: {
      getRefreshToken: async (credentials: CredentialsWithMagicLink) => {
        const deviceInfo = {
          device_name: getDeviceInfo().browser.name || 'unknown',
          device_os_version: getDeviceInfo().os.version?.toString() || 'unknown',
          device_uid: getDeviceUniqueId(),
        };
        if (credentials.username && credentials.password) {
          try {
            return apiClient.session.authenticate({
              username: credentials.username,
              password: credentials.password,
              ...deviceInfo,
            });
          } catch (errAuth) {
            if (!ApiError.isApiError(errAuth)) {
              bugsnag.notify(errAuth as Error);
            }
            return errAuth;
          }
        }
        if (credentials.token) {
          try {
            return apiClient.session.authenticateWithMagicLink({
              token: credentials.token,
              ...deviceInfo,
            });
          } catch (errAuthMagicLink) {
            if (!ApiError.isApiError(errAuthMagicLink)) {
              bugsnag.notify(errAuthMagicLink as Error);
            }
            return errAuthMagicLink;
          }
        }

        return null;
      },
      getAccessToken: ({ refresh_token }) => apiClient.session.getAccessToken(refresh_token),
      logout: ({ refresh_token }) =>
        apiClient.provider.logout(refresh_token).catch((e) => {
          if (!ApiError.isApiError(e)) {
            bugsnag.notify(e);
          }
          throw e;
        }),
    },
  };
};
